export { FastshiftResourcesPage } from "./src/fastshift-resources-page";
